/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const IAMUserState = {
    Active: 'active',
    Inactive: 'inactive',
    Registration: 'registration'
} as const;
export type IAMUserState = typeof IAMUserState[keyof typeof IAMUserState];

